// extracted by css-extract-rspack-plugin
export default {"cls1":"Modal-cls1_yx2","cls2":"Modal-cls2_nPN Modal-cls1_yx2"};